// A rolling gang sheet changes length at its bottom edge. Structural elements such as the
// bleed border and the content area also carry their outline as an SVG path, which is what
// the canvas draws, so the path's bottom edge has to move with the element's height.
//
// Only absolute rectangle-style paths (M, L, H, V, Z) can be moved this way; any other
// path is returned unchanged rather than distorted.
const SIMPLE_PATH = /^[\sMLHVZ0-9.,-]*$/;
const EPS = 1e-6;

function formatNumber(value: number): string {
  return String(Math.round(value * 1000) / 1000);
}

function moveBottomEdgeInPath(path: string, fromY: number, toY: number): string {
  if (!path || !SIMPLE_PATH.test(path)) {
    return path;
  }
  const moveY = (value: string) => (Math.abs(Number(value) - fromY) <= EPS ? formatNumber(toY) : value);
  return path.replace(/([MLV])\s*([^MLHVZ]*)/g, (command: string, letter: string, args: string) => {
    if (letter === 'V') {
      return `V${moveY(args.trim())}${args.endsWith(' ') ? ' ' : ''}`;
    }
    const parts = args.trim().split(/[\s,]+/);
    if (parts.length < 2) {
      return command;
    }
    const moved = parts.map((part, index) => (index % 2 === 1 ? moveY(part) : part));
    return `${letter}${moved.join(',')}${args.endsWith(' ') ? ' ' : ''}`;
  });
}

export default moveBottomEdgeInPath;
